import { Box } from "@mui/material";
import styled from "styled-components";

const Main = styled(Box)`
  font-size: 6px;
  position: absolute;
  top: 3px;
  right: 5px;
`;

// * app
const version = "1.1.2";

const VersionApp = () => {
  return (
    <Main>
      <span>{`Versión ${version}`}</span>
    </Main>
  );
};

export default VersionApp;
